<template>
    <div class="kra-change__container">
        <div class="old-kra display-col" v-if="kraChangeHistory.old_content">
            <strong>KRA: <span v-html="renderDiff('name', 'old')"></span></strong>
            <span>Yêu cầu thành phẩm:</span>
            <span v-html="renderDiff('request_result', 'old')"></span>
        </div>
        <div v-else class="old-kra display-col">

        </div>
        <div class="new-kra display-col" v-if="kraChangeHistory.new_content">
            <strong>KRA: <span v-html="renderDiff('name', 'new')"></span></strong>
            <span>Yêu cầu thành phẩm:</span>
            <span v-html="renderDiff('request_result', 'new')"></span>
        </div>
    </div>
</template>

<script>
import {diffChars, diffWords} from "diff";

export default {
    name: "KraChangeHistory",
    props: {
        kraChangeHistory: {
            type: Object,
            default: () => ({
                old_content: null,
                new_content: null
            })
        }
    },
    methods: {
        escapeHtml(str) {
            if (str === null || str === undefined) return '';
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        },
        renderDiff(field, mode) {
            const oldContent = this.kraChangeHistory?.old_content ?? null;
            const newContent = this.kraChangeHistory?.new_content ?? null;

            const oldTextRaw = oldContent?.[field] ?? '';
            const newTextRaw = newContent?.[field] ?? '';

            const oldExists = oldContent != null;
            const newExists = newContent != null;

            if (!oldExists && newExists) {
                if (mode === 'new') {
                    return `<span style="color: green">${this.escapeHtml(newTextRaw)}</span>`;
                }
                return '';
            }

            if (!newExists && oldExists) {
                if (mode === 'old') {
                    return `<span style="color: red">${this.escapeHtml(oldTextRaw)}</span>`;
                }
                return '';
            }

            const a = (oldTextRaw || '').normalize();
            const b = (newTextRaw || '').normalize();

            let diff = diffWords(a, b);
            const hasChange = diff.some(p => p.added || p.removed);
            if (!hasChange) {
                diff = diffChars(a, b);
            }
            return diff
                .map(part => {
                    if (part.removed && mode === 'old') {
                        return `<span style="color: red">${this.escapeHtml(part.value)}</span>`;
                    }
                    if (part.added && mode === 'new') {
                        return `<span style="color: green">${this.escapeHtml(part.value)}</span>`;
                    }
                    if (!part.added && !part.removed) {
                        return this.escapeHtml(part.value);
                    }
                    return '';
                })
                .join('');
        }
    }
};
</script>

<style scoped>
.kra-change__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border: 1px solid lightgray;
    border-radius: 3px;
}
.display-col {
    display: flex;
    flex-direction: column;
}
.old-kra {
    border-right: 1px solid lightgray;
    padding: 10px;
}
.new-kra {
    padding: 10px;
}
</style>
